import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GenericValidator } from '../../validation/general-validation';
import { AuthService } from '../../service/auth.service';
import { CompanyService } from 'src/app/service/company.service';
import { ConfigurationsService } from 'src/app/Service/configurations.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent implements OnInit {
  //Property declaration
  ForgotPWForm: FormGroup;
  displayMessage: { [key: string]: string } = {};
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;
  errorMsg: string = '';
  disablebtn: boolean = false;
  successMsg: string = '';
  logopath = '';
  CompanyCode: string;

  constructor(
    private formBuilder: FormBuilder,
    private configService: ConfigurationsService,
    private companyservice: CompanyService,
    private authService: AuthService
  ) {
    this.CompanyCode = localStorage.getItem('CompanyCode');
    //Raise Validation message
    this.authService.getValidationMessage().subscribe((resp) => {
      this.validationMessages = resp.ForgotPWForm;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });
  }

  ngOnInit(): void {
    //Intialize register form group for formcontrolname and validation
    this.ForgotPWForm = this.formBuilder.group({
      LoginId: ['', [Validators.required]],
    });

    setTimeout(() => {
      this.GetCompanyDetails(this.CompanyCode);
    }, 1000);

    // Call service for validation on valu change
    this.ForgotPWForm.valueChanges.subscribe(
      (value) =>
        (this.displayMessage = this.genericValidator.processMessages(
          this.ForgotPWForm
        ))
    );
  }

  // Call service for validation on blur
  blur(): void {
    this.displayMessage = this.genericValidator.processMessages(
      this.ForgotPWForm
    );
  }

  //Service call on save button
  onSubmit() {
    this.errorMsg = '';
    this.successMsg = '';
    if (this.ForgotPWForm.invalid) {
      this.ForgotPWForm.updateValueAndValidity();
      this.displayMessage = this.genericValidator.processMessages(
        this.ForgotPWForm,
        true
      );
      return;
    }
    var LoginId = this.ForgotPWForm.value.LoginId;
    this.disablebtn = true;
    let CompanyCode = localStorage.getItem('CompanyCode');

    this.authService.SendPassword(LoginId, CompanyCode).subscribe(
      (result) => {
        if (+result > 0) {
          this.successMsg = 'Send password on entered User Id !!';
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // get Company Details
  GetCompanyDetails(CompanyCode) {
    this.companyservice.GetCompanyDetailsByCompanyCode(CompanyCode).subscribe(
      (result) => {
        if (result) {
          if (result.LogoPath != null) {
            this.logopath =
              this.configService.serviceUrl('ServiceURL') + result.LogoPath;
          }
        }
      },
      (error) => {}
    );
  }
}
